export default __webpack_public_path__ + "static/media/aboutimg1.acd6b7c8.jpg";